"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.isVerticalTouchmoveDetected = exports.getFadeoutAnimationPosition = exports.getFadeoutAnimationIndex = exports.getSwipeTouchendIndex = exports.getSwipeTouchendPosition = exports.getSwipeTransformationCursor = exports.getTransformationItemIndex = exports.getSwipeShiftValue = exports.getItemCoords = exports.getIsLeftDirection = exports.shouldRecalculateSwipePosition = exports.getSwipeLimitMax = exports.getSwipeLimitMin = exports.shouldCancelSlideAnimation = exports.shouldRecalculateSlideIndex = exports.getUpdateSlidePositionIndex = exports.getActiveIndex = exports.getStartIndex = exports.getShiftIndex = void 0, exports.getShiftIndex = function (t, e) {
  return (t = void 0 === t ? 0 : t) + (e = void 0 === e ? 0 : e);
}, exports.getStartIndex = function (t, e) {
  if (void 0 === t && (t = 0), e = void 0 === e ? 0 : e) {
    if (e <= t) return e - 1;
    if (0 < t) return t;
  }

  return 0;
}, exports.getActiveIndex = function (t) {
  var e = t.startIndex,
      e = void 0 === e ? 0 : e,
      i = t.itemsCount,
      t = t.infinite;
  return void 0 !== t && t ? e : exports.getStartIndex(e, void 0 === i ? 0 : i);
}, exports.getUpdateSlidePositionIndex = function (t, e) {
  return t < 0 ? e - 1 : e <= t ? 0 : t;
}, exports.shouldRecalculateSlideIndex = function (t, e) {
  return t < 0 || e <= t;
}, exports.shouldCancelSlideAnimation = function (t, e) {
  return t < 0 || e <= t;
}, exports.getSwipeLimitMin = function (t, e) {
  var i = t.itemsOffset,
      t = t.transformationSet,
      t = void 0 === t ? [] : t,
      o = e.infinite,
      e = e.swipeExtraPadding;
  if (o) return (t[void 0 === i ? 0 : i] || {}).position;
  o = (t[0] || {}).width;
  return Math.min(void 0 === e ? 0 : e, void 0 === o ? 0 : o);
}, exports.getSwipeLimitMax = function (t, e) {
  var i = e.infinite,
      e = e.swipeExtraPadding,
      e = void 0 === e ? 0 : e,
      o = t.itemsCount,
      n = t.itemsOffset,
      r = t.itemsInSlide,
      r = void 0 === r ? 1 : r,
      t = t.transformationSet,
      t = void 0 === t ? [] : t;
  return i ? (t[(void 0 === o ? 1 : o) + exports.getShiftIndex(r, void 0 === n ? 0 : n)] || {}).position || 0 : exports.getItemCoords(-r, t).position + e;
}, exports.shouldRecalculateSwipePosition = function (t, e, i) {
  return -e <= t || Math.abs(t) >= i;
}, exports.getIsLeftDirection = function (t) {
  return (t = void 0 === t ? 0 : t) < 0;
}, exports.getItemCoords = function (t, e) {
  return (e = void 0 === e ? [] : e).slice(t = void 0 === t ? 0 : t)[0] || {
    position: 0,
    width: 0
  };
}, exports.getSwipeShiftValue = function (t, e) {
  return void 0 === t && (t = 0), void 0 === e && (e = []), exports.getItemCoords(t, e).position;
}, exports.getTransformationItemIndex = function (t, e) {
  return void 0 === e && (e = 0), (t = void 0 === t ? [] : t).findIndex(function (t) {
    return t.position >= Math.abs(e);
  });
}, exports.getSwipeTransformationCursor = function (t, e, i) {
  void 0 === t && (t = []), void 0 === e && (e = 0), void 0 === i && (i = 0);
  t = exports.getTransformationItemIndex(t, e);
  return exports.getIsLeftDirection(i) ? t : t - 1;
}, exports.getSwipeTouchendPosition = function (t, e, i) {
  void 0 === i && (i = 0);
  var o = t.infinite,
      n = t.autoWidth,
      r = t.isStageContentPartial,
      s = t.swipeAllowedPositionMax,
      t = t.transformationSet,
      i = exports.getSwipeTransformationCursor(t, i, e),
      e = exports.getItemCoords(i, t).position;

  if (!o) {
    if (n && r) return 0;
    if (s < e) return -s;
  }

  return -e;
}, exports.getSwipeTouchendIndex = function (t, e) {
  var i = e.transformationSet,
      o = e.itemsInSlide,
      n = e.itemsOffset,
      r = e.itemsCount,
      s = e.infinite,
      d = e.isStageContentPartial,
      a = e.activeIndex,
      e = e.translate3d;
  if (!s && (d || e === Math.abs(t))) return a;
  d = exports.getTransformationItemIndex(i, t);
  return s ? d < (e = exports.getShiftIndex(o, n)) ? r - o - n + d : e + r <= d ? d - (e + r) : d - e : d;
}, exports.getFadeoutAnimationIndex = function (t) {
  var e = t.infinite,
      i = t.activeIndex,
      t = t.itemsInSlide;
  return e ? i + t : i;
}, exports.getFadeoutAnimationPosition = function (t, e) {
  var i = e.activeIndex,
      e = e.stageWidth;
  return t < i ? (i - t) * -e || 0 : (t - i) * e || 0;
}, exports.isVerticalTouchmoveDetected = function (t, e, i) {
  return t < (i = void 0 === i ? 0 : i) || t < .1 * e;
};